import { useNavigate, useSearchParams } from "react-router";

import { AcceptInvitationSetPasswordForm } from "@/components";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { useVerifyInvitation } from "@/hooks/queries";

import laborupBlueGear from "@/assets/laborup_blue_gear.svg";
import laborupDarkText from "@/assets/laborup_dark_text.svg";

const privacyPolicyUrl =
  "https://app.termly.io/policy-viewer/policy.html?policyUUID=6bdfcf13-9de3-4a6a-b165-7a62a45716bd";
const termsOfServiceUrl =
  "https://app.termly.io/policy-viewer/policy.html?policyUUID=ef33f2dc-038c-4293-a4a2-5a7fcee8d8d1";

const InvalidMessage = () => {
  return (
    <div className="flex max-w-[384px] flex-col gap-[6px] rounded-lg border border-slate-200 p-6">
      <p className="text-2xl font-semibold text-slate-900">
        This link is invalid
      </p>
      <p className="text-sm text-slate-500">
        The invitation link is invalid. Please reach out to the person who
        invited you to request a new one.
      </p>
    </div>
  );
};

const SetPassword = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex items-center gap-2">
        <img
          alt="Laborup blue gear"
          className="h-[24px]"
          src={laborupBlueGear}
        />
        <img
          alt="Laborup dark text"
          className="h-[18px]"
          src={laborupDarkText}
        />
      </div>
      <Card className="max-w-[384px]">
        <CardHeader>
          <CardTitle className="text-2xl">Set your password</CardTitle>
          <CardDescription>
            Please set your password for your Laborup account
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <AcceptInvitationSetPasswordForm
            onSuccess={() => {
              void navigate("/sign-in");
            }}
          />
          <p className="text-sm text-slate-500">
            By creating your account, you agree to Laborup&apos;s{" "}
            <a
              className="text-primary-900 underline"
              href={termsOfServiceUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              className="text-primary-900 underline"
              href={privacyPolicyUrl}
              rel="noopener noreferrer"
              target="_blank"
            >
              Privacy Policy
            </a>
            .
          </p>
        </CardContent>
      </Card>
    </>
  );
};

export const AcceptInvitationPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { status } = useVerifyInvitation({
    token: token ?? "",
  });

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-8">
      {status === "success" ? <SetPassword /> : <InvalidMessage />}
    </div>
  );
};
